var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dash-layout',[_c('template',{slot:"dash-title"},[_vm._v("Tools")]),_c('template',{slot:"dash-body"},[_c('Tools')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }